import enviro from 'enviro';
export const LANDING_PAGES_ACCESS = 'landingpages-access';
export const LANDING_PAGES_WRITE = 'landingpages-write';
export const LANDING_PAGES_MULTILANGUAGE = 'landingpages-multilanguage';
export const LANDING_PAGES_TRUSTED = 'landingpages-trusted';
export const LANDING_PAGES_PUBLISH = 'landingpages-publish';
export const UPDATE_LANDING_PAGES_SCOPES = [LANDING_PAGES_ACCESS, LANDING_PAGES_WRITE, LANDING_PAGES_PUBLISH];
export const SITE_PAGES_ACCESS = 'sitepages-access';
export const SITE_PAGES_WRITE = 'pages-write';
export const SITE_PAGES_MULTILANGUAGE = 'sitepages-multilanguage';
export const SITE_PAGES_PUBLISH = 'pages-publish';
export const SITE_PAGES_PASSWORD_PROTECTION = 'sitepages-password-protection';
export const LANDING_PAGES_PASSWORD_PROTECTION = 'landingpages-password-protection';
export const LANDING_PAGES_PRIVATE_CONTENT_MANAGE = 'landingpages-private-content-manage';
export const SITE_PAGES_PRIVATE_CONTENT_MANAGE = 'pages-private-content-manage';
export const PAGE_SUBCATEGORY_MOVE_ACCESS = 'page-subcategory-move';
export const DYNAMIC_PAGE_ACCESS = 'dynamic-page-access';
export const MARKETING_CONTENT_RESTRICTED_WRITE = 'marketing-content-restricted-write';
export const AB_TESTING_ACCESS = 'content-ab-testing';
export const MAB_TESTING_ACCESS = 'content-mab-testing';
export const LANDING_PAGES_BULK_DOMAIN_UPDATE = 'landingpages-bulk-domain-change';
export const SITE_PAGES_BULK_DOMAIN_UPDATE = 'sitepages-bulk-domain-change';
export const SOCIAL_ACCESS_SCOPE = 'social-access';
export const CONTENT_REMIX_WRITE_SCOPE = 'content-remix-write';
export const SITE_PAGES_NO_BRANDING = 'website-pages-no-branding';
export const LANDING_PAGES_NO_BRANDING = 'landingpages-no-branding';
export const SITE_PAGES_AUTOTRANSLATE = 'sitepages-auto-translate';
export const LANDING_PAGES_AUTOTRANSLATE = 'landingpages-auto-translate';
export const AI_LANDING_PAGES_ACCESS = 'ai-landing-pages-access';
export const UPDATE_SITE_PAGES_SCOPES = [SITE_PAGES_ACCESS, SITE_PAGES_WRITE, SITE_PAGES_PUBLISH];
// sitepages-password-protection
const SITEPAGES_PASSWORD_PROTECTION_SCOPE_ID = enviro.isQa() ? 3280 : 1867;
// landingpages-password-protection
const LANDINGPAGES_PASSWORD_PROTECTION_SCOPE_ID = enviro.isQa() ? 3279 : 1866;
// dynamic-page-access
const DYNAMIC_PAGE_ACCESS_SCOPE_ID = enviro.isQa() ? 3381 : 1960;
// marketing-content-restricted-write
const MARKETING_CONTENT_RESTRICTED_WRITE_SCOPE_ID = enviro.isQa() ? 1309 : 1059;
export const ScopeNameToId = {
  [SITE_PAGES_PASSWORD_PROTECTION]: SITEPAGES_PASSWORD_PROTECTION_SCOPE_ID,
  [LANDING_PAGES_PASSWORD_PROTECTION]: LANDINGPAGES_PASSWORD_PROTECTION_SCOPE_ID,
  [DYNAMIC_PAGE_ACCESS]: DYNAMIC_PAGE_ACCESS_SCOPE_ID,
  [MARKETING_CONTENT_RESTRICTED_WRITE]: MARKETING_CONTENT_RESTRICTED_WRITE_SCOPE_ID
};